import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withStyles } from "@mui/styles";
import {
  getMindfile,
  getMultiuserLocations as getMindfileItemLocations,
  getMultiuserMindfiles,
} from '../../../../state/actions/getDataActions';
import {Avatar, Button, Collapse, FormControl, FormLabel, TableCell,} from '@mui/material';
import DataTable from "../../../util/data-table/DataTable";
import BindViewOptions from "../../../util/data-table/BindViewOptions";
import {formatLocation} from "../../../../helpers/FormatUtils";
import {API_ROOT} from "../../../../baseUrls";
import UsageToolbar from "../../admin/usage/UsageToolbar";
import {LocationIcon} from "../../../../helpers/Icons";
import {ExpandLess} from "@mui/icons-material";
import ItemsMap from "../../explore/items/table/ItemsMap";

const styles = {
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
  sizeLabel:{
    fontSize:'0.825em',
    whiteSpace:'nowrap',
    marginLeft:'0.35em'
  },
  locationCell: {
    // maxWidth:'calc(max(9dvw,12em))',
    // width: '6dvw',
    whiteSpace:'nowrap',
    // minWidth:'5em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  locationText: {
    whiteSpace:'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  mapControls: {
    display: 'flex',
    marginTop: '1em',
    padding: '0',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative',
    backgroundColor: '#ffffff'
  },
  mapLabel: {
    flexShrink: 0,
    fontSize: '0.85rem',
    marginTop:'-12px',
    position: 'absolute',
    backgroundColor: 'inherit',
    borderRadius: '4px',
    zIndex: 10,
    border: '1px solid rgba(0, 0, 0, 0)',
    '&> button':{
      // textTransform: 'none',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
      zIndex: 10,
    },
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      // backgroundColor: '#f5f5f5',
    },
    marginLeft: '1em'
  },
};

function simpleCell(func, key, data, isSelected, openDataView, classes){
  return (
    <TableCell id={`${key}Cell`} key={key}>
      {func(data)}
    </TableCell>);
}

function dateCell(func, key, data, isSelected, openDataView, classes, history, column){
  let dateString = func(data);
  if(dateString === null || dateString === ""){
    return <TableCell id={`${key}Cell`} key={key}></TableCell>;
  }
  let date = new Date(dateString);
  return (<TableCell id={`${key}Cell`} key={key} style={{width:'5em', whiteSpace:'nowrap'}} >
    <div style={{display:'inline-block', textAlign:'right'}}>
      <div style={{whiteSpace:'nowrap'}} >{date.toLocaleDateString()}</div>
      <div className={classes.cellSubtext} >{date.toLocaleTimeString()}</div>
    </div>
  </TableCell>);
}

export function locationCell(func, key, data, isSelected, openDataView, classes, history, column){
  return (<TableCell key={key} >
    {formatLocation("locationCell", func(data), classes)}
  </TableCell>);
}


function subCurrentDate({d=0,m=0,y=0,h=0,min=0,start=false,end=false}){
  const date = new Date();
  date.setDate(date.getDate() - d);
  date.setMonth(date.getMonth() - m);
  date.setFullYear(date.getFullYear() - y);
  date.setHours(date.getHours() - h);
  date.setMinutes(date.getMinutes() - min);
  return dateTrunc(date, {start, end});
}
function dateTrunc(date, {start=true, end=false}){
  if(!date || typeof(date.getMonth) !== "function") {
    return date;
  }
  if(start){
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
  }else if(end){
    date.setHours(23)
    date.setMinutes(59)
    date.setSeconds(59)
    date.setMilliseconds(999)
  }
  return date;
}

class MultiuserExplorer extends Component {
  //
  // const viewMindfile = mindfileId => () => {
  //   getMindfile(mindfileId, () => this.history.push('/explore'));
  // }
  //
  // const manageMindfile = mindfileId => () => {
  //   getMindfile(mindfileId, () => this.history.push('/admin/current'), true);
  // }
  filterDefinitions = [
    // { label: "User Activated", key: "activated", enabled: false, visible: true, options: (opts) => [{name:'Activated', value: 1}, {name: 'Not Activated', value: 0}] },
    // { label: "User Logged In", key: "logged_in", enabled: true, visible: true, options: (opts) => [{name:'Has Logged In', value: 1}, {name: 'Has Not Logged In', value: 0}] },
    // { label: "Status", key: "status", enabled: true, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
    // { label: "Keywords", key: "keywords", enabled: true, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
    // { label: "People", key: "people", enabled: true, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
    // { label: "Folders", key: "folders", enabled: true, visible: true, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
    // { label: "Emotions", key: "emotions", enabled: true, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
    // { label: "Bemes", key: "bemes", enabled: true, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
    // { label: "Item Types", key: "item_data_types", enabled: true, visible: true, options: (opts) => itemTypes },
    // { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => uploadTypes},
    // { label: "Item Created", key: "mindfile_items.created_at", enabled: true, visible: false, options: (opts) => [] },
    // { label: "Item Updated", key: "mindfile_items.updated_at", enabled: true, visible: false, options: (opts) => [] },
    // { label: "Mindfile Created", key: "mindfiles.created_at", enabled: true, visible: false, options: (opts) => [] },
    // { label: "Mindfile Updated", key: "mindfiles.updated_at", enabled: true, visible: false, options: (opts) => [] },
    // { label: "Last Login", key: "users.last_login_at", enabled: true, visible: false, options: (opts) => [] },
  ];
  // "id", "name", "created_at", "owner_id", "private", "friends",
  // "user_id", "username", "email", "last_login_at",
  // "item_count", "upload_count",
  // "max_view", "max_download", "max_share",
  // "sum_view", "sum_download", "sum_share",
  // "avg_view", "avg_download", "avg_share",
  // "max_size", "sum_size", "avg_size",
  // "last_created", "last_updated",
  // "locality", "country_display", "region_display", "latitude", "longitude"
  columns = [
    // {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
    {key: 'mindfile_name', header: { label: 'Mindfile', sort: "mindfiles.name" }, cell: simpleCell.bind(this, (m) =>
        <div onClick={() => {
          this.props.getMindfile(m.id, () => this.props.history.push('/explore'));
        }}
             style={{cursor:'pointer'}}
        >
          <div style={{display:"flex", alignItems:'center', gap:'0.5rem'}}>
            <Avatar
              alt={m.mindfile_name}
              src={`${API_ROOT}/mindfiles/${m.id}/avatar/thumbnail?size=48&ts=${m.url_ts}`}
              style={{ border: "2px solid #003e58", width:'36px', height:'36px'}}
            />
            <div style={{textOverflow:'ellipsis', overflow:"hidden"}}>{m.mindfile_name}</div>
          </div>
        </div>), enabled: true },
    {key: 'username', header: { label: 'Owner', sort: 'users.username' }, cell: simpleCell.bind(this, (d) => d.username), enabled: true },
    {key: 'location', header: { label: 'Location', sort: 'locations.country', nulls: true }, cell: locationCell.bind(this, (d) => d), enabled: true },
    // {key: 'email', header: { label: 'Email', sort: 'users.email' }, cell: simpleCell.bind(this, (d) => d.email), enabled: true },
    {key: 'created_at', header: { label: 'Created', sort: 'mindfiles.created_at', asc: false }, cell: dateCell.bind(this, (d) => d.created_at), enabled: true },
    {key: 'updated_at', header: { label: 'Updated', sort: 'mindfiles.updated_at', asc: false }, cell: dateCell.bind(this, (d) => d.updated_at), enabled: true },
    // {key: 'last_login_at', header: { label: 'Last Login', sort: 'users.last_login_at', asc: false, nulls: true}, cell: dateCell.bind(this, (d) => d.last_login_at), enabled: true },

    // {key: 'item_count', header: { label: 'Items', sort: 'items.item_count', asc: false, nulls: true }, cell: simpleCell.bind(this, (d) => d.item_count), enabled: true },
    // {key: 'upload_count', header: { label: 'Uploads', sort: 'items.upload_count', asc: false, nulls: true }, cell: simpleCell.bind(this, (d) => d.upload_count), enabled: true },
    //
    // {key: 'max_size', header: { label: 'Top Size', sort: 'items.max_size', asc: false, nulls: true, size:"small" }, cell: sizeCell.bind(this, (d) => d.max_size), enabled: true },
    // {key: 'sum_size', header: { label: 'Total Size', sort: 'items.sum_size', asc: false, nulls: true, size:"small" }, cell: sizeCell.bind(this, (d) => d.sum_size), enabled: true },
    //
    // {key: 'avg_size', header: { label: 'Avg Size', sort: 'items.avg_size', asc: false, nulls: true, size:"small" }, cell: sizeCell.bind(this, (d) => d.avg_size), enabled: true },
    // {key: 'max_view', header: { label: 'Top View', sort: 'items.max_view', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.max_view), enabled: true },
    // {key: 'sum_view', header: { label: 'Total View', sort: 'items.sum_view', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.sum_view), enabled: true },
    //
    // {key: 'avg_view', header: { label: 'Avg View', sort: 'items.avg_view', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.avg_view), enabled: true },
    // {key: 'max_download', header: { label: 'Top Download', sort: 'items.max_download', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.max_download), enabled: true },
    // {key: 'sum_download', header: { label: 'Total Download', sort: 'items.sum_download', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.sum_download), enabled: true },
    //
    // {key: 'avg_download', header: { label: 'Avg Download', sort: 'items.avg_download', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.avg_download), enabled: true },
    // {key: 'max_share', header: { label: 'Top Share', sort: 'items.max_share', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.max_share), enabled: true },
    // {key: 'sum_share', header: { label: 'Total Share', sort: 'items.sum_share', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.sum_share), enabled: true },
    // {key: 'avg_share', header: { label: 'Avg Share', sort: 'items.avg_share', asc: false, nulls: true, size:"small" }, cell: simpleCell.bind(this, (d) => d.avg_share), enabled: true },
    //
    // {key: 'last_created', header: { label: 'Last Created', sort: 'items.last_created', asc: false, nulls: true, size:"small" }, cell: dateCell.bind(this, (d) => d.last_created), enabled: true },
    // {key: 'last_updated', header: { label: 'Last Updated', sort: 'items.last_updated', asc: false, nulls: true, size:"small" }, cell: dateCell.bind(this, (d) => d.last_updated), enabled: true },
    //
    // {key: 'private', header: { label: 'Private', sort: 'mindfile.private' }, cell: simpleCell.bind(this, (d) => d.private ? "yes" : "no"), enabled: true },
    // {key: 'friends', header: { label: 'Friends', sort: 'mindfile.friends' }, cell: simpleCell.bind(this, (d) => d.friends ? "yes" : "no"), enabled: true },

    // {key: 'icons', header: { label: '', sort: null }, cell: iconsCell, enabled: true },
    // {key: 'description', header: { label: 'Description', sort: 'folders.description', nulls: true }, cell: descriptionCell, enabled: true },
    // {key: 'count', header: { label: 'Items', sort: 'folders.item_count', asc: false }, cell: itemCountCell, enabled: true },
    // {key: 'created', header: { label: 'Added', sort: 'folders.created_at', asc: false }, cell: createdCell, enabled: true },
    // {key: 'updated', header: { label: 'Modified', sort: 'folders.updated_at', asc: false }, cell: updatedCell, enabled: true },
  ];
  columnMap = Object.fromEntries(this.columns.map(col => [col.key,col]));

  defaultViewOpts = {
    rowsPerPage: 12,
    orders: [{f: 'mindfiles.updated_at', d: false, n:true}],
    viewMode: 'List',
    visibleColumns: Object.assign({}, ...this.columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden})))
  };

  defaultDateFilters = (filters) => [
    // { key: "activated", selectedItems: filters.activated },
    // { key: "logged_in", selectedItems: filters.logged_in, },
    // { key: "status", selectedItems: filters.status, },
    // { key: "item_data_types", selectedItems: filters.item_data_types, },
    // { key: "upload_types", selectedItems: filters.upload_types, },
    // { key: "mindfile_items.created_at", selectedItems: [] },
    // { key: "mindfile_items.updated_at", selectedItems: [] },
    // { key: "mindfiles.created_at", selectedItems: [] },
    // { key: "mindfiles.updated_at", selectedItems: [] },
    // { key: "users.last_login_at", selectedItems: [] },
  ];

  defaultFilters = (filters) => [
    // { key: "activated", selectedItems: [], },
    // { key: "logged_in", selectedItems: [], },
    // { key: "status", selectedItems: [], },
    // // { key: "keywords", selectedItems: [], },
    // // { key: "people", selectedItems: [], },
    // // { key: "folders", selectedItems: [], },
    // // { key: "emotions", selectedItems: [], },
    // // { key: "bemes", selectedItems: [], },
    // { key: "item_data_types", selectedItems: [], },
    // { key: "upload_types", selectedItems: [], },
    // // { key: "mindfile_items.created_at", selectedItems: [subCurrentDate({m: 1}), ""] },
    // // { key: "mindfile_items.updated_at", selectedItems: [] },
    // // { key: "mindfiles.created_at", selectedItems: [] },
    // // { key: "mindfiles.updated_at", selectedItems: [] },
    // // { key: "users.last_login_at", selectedItems: [] },
  ];

  state = {
    pageKey: "/social/multi-user-mindfiles",
    title: 'Multi-User Mindfiles',
    loading: true,
    viewOptsLoaded: false,
    controller: {
      page: 1,
      rowsPerPage: this.defaultViewOpts.rowsPerPage,
      orders: this.defaultViewOpts.orders,
      search: null,
    },
    mapBounds: null,
    items: [],
    filter_count: 0,
    folderList: [],
    filterSelections: this.defaultFilters(),
    selectedIds: [],
    viewMode: 'List',
    viewModeOptions: ['List'],
    isAddItemDialogOpen: false,
    isViewItemDialogOpen: false,
    addItemType: null,
    isUploadDialogOpen: false,
    isAddFolderDialogOpen: false,
    tableView: {
      addButtons: [],
      viewMode: this.defaultViewOpts.viewMode,
      viewModeOptions: ['List'],
      filtersOpen: false,
      columnsOpen: false,
      visibleColumns: this.defaultViewOpts.visibleColumns
    },
    dateField: "mindfiles.updated_at",
    dateStart: subCurrentDate({m:1}),
    dateEnd: new Date(),
  };

  filters = this.filterDefinitions.map((filter, index) => ({
    ...filter, index: index, handleSelect: this.handleFilterSelect.bind(this, index), addFilterSelect: this.addFilterSelect.bind(this, index)
  }));

  handleFilterSelect(index, selections){
    let newFilters = [...this.state.filterSelections];
    newFilters[index] = {...(newFilters[index]), selectedItems: selections};
    this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
  }

  addFilterSelect(index, optionId){
    let newFilters = [...this.state.filterSelections];
    let newSelection = [...newFilters[index].selectedItems];
    if(newSelection.indexOf(optionId) === -1){
      newSelection.push(optionId);
      newFilters[index] = {...(newFilters[index]), selectedItems: newSelection};
      this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
    }
  }

  filterDates(field, start, end){
    const index = this.filters.findIndex(x => x.key === field);
    if(index < 0){
      return;
    }
    const filter = this.filters[index];
    if(filter){
      // if(typeof(start.getMonth) === "function"){
      //   start.setHours(0)
      //   start.setMinutes(0)
      //   start.setSeconds(0)
      //   start.setMilliseconds(0)
      // }
      // if(typeof(end.getMonth) === "function"){
      //   end.setHours(23)
      //   end.setMinutes(59)
      //   end.setSeconds(59)
      //   end.setMilliseconds(999)
      // }
      const curFilters = Object.fromEntries(this.state.filterSelections.map(f => [f.key, f.selectedItems]))
      const newFilters = this.defaultDateFilters(curFilters);
      newFilters[index] = {...(newFilters[index]), selectedItems: [start, end]};
      this.setState({filterSelections: newFilters, controller: {...this.state.controller, page: 1}});
    }
  }

  // componentDidMount() {
    // this.props.getFolderList(this.props.mindfile.id);
    // this.props.getFilterValues(this.props.mindfile.id);
    // this.props.setSelectedItems({});
  // }

  navFolderView(folderId, e) {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    this.props.history.push(`/explore/folder/${folderId}`);
  }

  fetchItems(fetchLocations=false) {
    if(!this.props.mindfile.id) return;
    this.setState({loading: true});
    let fetchFilters =  Object.fromEntries(this.filters.map((f,index) => f.enabled && !!this.state.filterSelections[index].selectedItems && this.state.filterSelections[index].selectedItems.length > 0 ? [f.key, this.state.filterSelections[index].selectedItems] : null).filter(item => !!item));
    this.props.getMultiuserMindfiles(this.state.pageKey, this.props.mindfile.id, this.state.controller, fetchFilters, this.state.mapBounds, () => {
      // if(this.props.mindfileFilterValues.updated) {
      //   this.props.getFilterValues(this.props.mindfile.id, this.props.mindfileFilterValues.updated);
      // }
      this.setState({loading: false});
    });
  }

  handlePageChange(event, page){
    let maxPage = Math.max(1, !this.props.filter_count ? page : Math.ceil(this.props.filter_count / this.state.controller.rowsPerPage));
    let newPage = Math.min(Math.max(1, page), maxPage);
    if(newPage === this.state.controller.page){
      return;
    }
    this.setState({...this.state,
      controller: {
        ...this.state.controller,
        page: newPage
      },
    });
  }

  afterItemsChange(ids){
    let maxPage = Math.max(1, !this.props.filter_count ? this.state.controller.page : Math.ceil((this.props.filter_count - ids.length) / this.state.controller.rowsPerPage));
    if(this.state.controller.page > maxPage){
      this.handlePageChange(null, maxPage);
    }else{
      this.fetchItems();
    }
  }

  handleChangeRowsPerPage(event){
    const newRows = parseInt(event.target.value);
    let itemFirst = Math.max(0, ((this.state.controller.page - 1) * this.state.controller.rowsPerPage) + 1);
    if(!!this.props.filter_count){
      itemFirst = Math.min(this.props.filter_count, itemFirst);
    }
    const page = Math.floor(itemFirst / newRows) + 1;
    let maxPage = Math.max(1, !this.props.filter_count ? page : Math.ceil(this.props.filter_count /newRows));
    let newPage = Math.min(Math.max(1, page), maxPage);
    this.setState((prevState, props) => ({controller: {
        ...prevState.controller,
        rowsPerPage: newRows,
        page: newPage
      }}));
  }


  handleMapOpen(open){
    this.setState({mapOpen:open});
    if(!open) {
      this.setMapBounds((prevState, props) => null);
    }
  }

  setMapBounds(prevStateFunc){
    return this.setState((prevState, props) => {
      return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
    })
  }

  getItemMap() {
    return [
      {
        button: {
          key: 'mapOpen',
          action: () => this.handleMapOpen(!this.state.mapOpen),
          label: <>Map</>,
          startIcon: <LocationIcon/>,
          open: this.state.mapOpen
        },
        panel: (
          <Collapse key='map' in={this.state.mapOpen} timeout="auto" unmountOnExit>
            <FormControl id='dataMap' className={this.props.classes.mapControls}>
              <FormLabel className={this.props.classes.mapLabel} component="div">
                <Button onClick={() => this.handleMapOpen(!this.state.mapOpen)}>
                  Map<ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}}/>
                </Button>
              </FormLabel>
              <ItemsMap
                mapOpen={this.state.mapOpen}
                mindfileId={this.props.mindfile.id}
                isDialogOpen={false}
                openItemViewDialog={null}
                getMindfileItemLocations={this.props.getMindfileItemLocations.bind(this)}
                itemList={this.props.itemsKey !== this.state.pageKey ? [] : this.props.mindfiles || []}
                itemMap={{}}
                selectedIds={[]}
                mapBounds={this.state.mapBounds}
                setMapBounds={(bounds) => this.setMapBounds((prevState, props) => (bounds))}
                controller={this.state.controller}
                filters={this.filters}
                filterSelections={this.state.filterSelections}
              />
            </FormControl>
          </Collapse>
        )
      }
    ];
  }
  render() {
    return (
      <>
        <div style={{position:'relative', display: 'flex', flexDirection:'row', flexWrap:'wrap-reverse', alignItems: 'center', margin: '0 0 1rem', gap: '0.5em 0'}}>
          <div style={{flexGrow:1}}>
            <h2 id="pageTitle" style={{textAlign: 'center', fontWeight: '400', wordBreak:'break-word', margin: '0 auto'}}>{this.state.title}</h2>
          </div>
        </div>
        <DataTable
          mindfileId={this.props.mindfile.id}
          itemList={this.props.mindfiles || []}
          // itemMap={this.props.itemMap}
          itemCount={this.props.filter_count}
          fetchItems={this.fetchItems.bind(this)}
          folderList={this.props.folderList}
          addFolder={()=>{}}
          removeItems={()=>{}}
          moveItems={()=>{}}
          columns={this.columns}
          columnMap={this.columnMap}
          filters={this.filters}
          filterSelections={this.state.filterSelections}
          clearFilterSelections={() => this.setState({filterSelections: this.defaultFilters()})}
          mindfileFilterValues={this.props.mindfileFilterValues}
          selectedIds={[]}
          setSelectedIds={null}
          selectedItems={{}}
          setSelectedItems={null}
          controller={this.state.controller}
          setController={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevStateFunc(prevState, props)}})
            })
          }}
          mapBounds={this.state.mapBounds}
          setMapBounds={(prevStateFunc) => {
            return this.setState((prevState, props) => {
              return ({controller: {...prevState.controller, page: 1}, mapBounds: prevStateFunc(prevState, props)})
            })
          }}
          loading={this.state.loading}
          setLoading={(isLoading) => this.setState({loading: isLoading})}
          viewOptsLoaded={this.state.viewOptsLoaded}
          bindViewOptions={
            <BindViewOptions
              pageKey={this.state.pageKey}
              parentState={this.state}
              parentProps={this.props}
              setParentState={this.setState.bind(this)}
              defaultViewOpts={this.defaultViewOpts}
              loaded={this.state.viewOptsLoaded}
              setLoaded={loaded => this.setState({viewOptsLoaded: loaded})}
            />
          }
          openDataView={()=>{}}
          tableToolbar={this.getItemMap()}
          selectedToolbar={(
            <UsageToolbar
              controller={this.state.controller}
              itemCount={this.props.filter_count}
              pageItemCount={this.props.mindfiles.length}
              handlePageChange={this.handlePageChange.bind(this)}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
              mindfileUserLevel={this.props.mindfileUserLevel}
            />
          )}

          viewMode={this.state.tableView.viewMode}
          setViewMode={(e) => this.setState({tableView: {...this.state.tableView, viewMode: e.target.value}})}
          viewModeOptions={this.state.tableView.viewModeOptions}
          filtersOpen={this.state.tableView.filtersOpen}
          setFiltersOpen={(open) => this.setState({tableView: {...this.state.tableView, filtersOpen: open}})}
          columnsOpen={this.state.tableView.columnsOpen}
          setColumnsOpen={(open) => this.setState({tableView: {...this.state.tableView, columnsOpen: open}})}
          visibleColumns={this.state.tableView.visibleColumns}
          setVisibleColumns={(columns) => this.setState({tableView: {...this.state.tableView, visibleColumns: columns}})}
          mindfileUserLevel={this.props.mindfileUserLevel}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    itemsKey: state.multiUserMindfiles?.pageKey,
    mindfiles: state.multiUserMindfiles?.mindfiles || [],
    filter_count: state.multiUserMindfiles?.filter_count || 0,
    // itemMap: !!state.usageData && !! state.usageData.usage_data ? Object.fromEntries(state.usageData.usage_data.map((item) => [item.id, item])) : {},
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
    folderList: state.folderList,
    mindfileFilterValues: state.mindfileFilterValues,
    selectedItems: {},
    mindfileUserLevel: 3,
    isAdmin: false,
    isCurrentMindfileOwner: false,
    isCurrentMindfileContributor: false,
  };
}

const setSelectedItems = () => {};
const mapDispatchToProps = {
  getMultiuserMindfiles,
  setSelectedItems,
  getMindfile,
  getMindfileItemLocations,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MultiuserExplorer));
